import Gunnery from "./components/Gunnery"
import Hero from "./components/Hero"
import KeyBlanco from "./components/KeyBlanco"
import Port from "./components/Port"
import World from "./components/World"
const Places = () => {
  return (
    <div>
        <Hero />
        <World />
        <Gunnery />
        <Port/>
        <KeyBlanco />
    </div>
  )
}

export default Places